import { Monitor, Moon, Sun } from 'lucide-react';
import { useEffect, useState } from 'react';
import {
  applyTheme,
  readThemePreference,
  setThemePreference,
  type ThemePreference
} from '@altios/theme/theme';

const options: Array<{ value: ThemePreference; label: string; icon: typeof Sun }> = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'System', icon: Monitor }
];

export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const [value, setValue] = useState<ThemePreference>(() => readThemePreference());

  useEffect(() => {
    applyTheme(value);
  }, [value]);

  function selectTheme(next: ThemePreference) {
    setValue(next);
    setThemePreference(next);
  }

  return (
    <div className={`altios-theme-toggle ${compact ? 'altios-theme-toggle--compact' : ''}`} role="group" aria-label="Color theme">
      {options.map(({ value: optionValue, label, icon: Icon }) => (
        <button
          key={optionValue}
          type="button"
          className="altios-theme-toggle__option"
          data-active={value === optionValue ? 'true' : 'false'}
          onClick={() => selectTheme(optionValue)}
          aria-pressed={value === optionValue}
          title={`${label} theme`}
        >
          <Icon size={15} strokeWidth={2} aria-hidden="true" />
          {compact ? <span className="sr-only">{label}</span> : <span>{label}</span>}
        </button>
      ))}
    </div>
  );
}
